import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-chapter-revise-tab',
  templateUrl: './chapter-revise-tab.component.html',
  styleUrls: ['./chapter-revise-tab.component.css']
})
export class ChapterReviseTabComponent implements OnInit {

  pauseOnHover = false;
  pauseOnFocus = false;

  @Input() tabSubject: string;
  @Input() isMemoryCardsAvailable:any;

  topicCardList: any = []

  dummyTopicSummaries=[1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  storiesList:any =[];
  allTopicsSummeryProgress: any;
  cmsInfo:any;

  constructor(public selfLearnService:SelfLearnService, public router:Router) { }

  ngOnInit(): void {
    this.cmsInfo = JSON.parse(localStorage.getItem('cmsInfo'))
    this.getTopicSummaryProgress();
    if(this.isStoriesVisible()){
      this.getStoriesForExamNodeIds();
    }
   
  }

  publishedVideoAndFlashcardCount(){
    this.selfLearnService.publishedVideoAndFlashcardCount().subscribe((resp:any) => {
      console.log(resp.data);
      if(resp?.data){
        this.topicCardList = resp?.data;
        this.topicCardList.map((item:any) => {
          if(item.flashcardTaggedQuestionsCount > 0){
            item.publishedFlashcardCount = item.publishedFlashcardCount + 1;
          }
          return {...item};
        });
      }
    })
  }

  getTopicSummaryProgress(){
    this.selfLearnService.getTopicSummaryProgress().subscribe((resp:any) => {
      this.allTopicsSummeryProgress = resp?.data;
      this.publishedVideoAndFlashcardCount();
    })
  }

  getStoriesForExamNodeIds(){
    this.selfLearnService.getStoriesForExamNodeIds('articulate').subscribe((resp:any) => {
      this.storiesList = resp?.data;

    })
  }

  

  navigateToTopicsViewAll(){
    localStorage.setItem('selfLearnPreviousPage' , 'chapter');
    this.router.navigateByUrl('selfLearn-V2/topic-summary');
  }
  isStoriesVisible(){
    let gradeId =this.cmsInfo.cmsGradeId;
    if(gradeId>=6 && gradeId<=10){
      return true
    }else{
      return false;
    }
  }
}
